import ManagerTrackReport from './views/ManagerTrackReport';
import RealisationErrorsReport from './views/RealisationErrorsReport';
import MissingDocumentsReport from './views/MissingDocumentsReport';
import PaymentReport from './views/PaymentReport';
import DispatcherReport from './views/DispatcherReport';
import TransferReport from './views/TransferReport';
import ForwardingReport from './views/ForwardingReport';
import NoForwardingReport from './views/NoForwardingReport';
import RoutelistReport from './views/RoutelistReport';
import ServicesReport from './views/ServicesReport';

export default {
    routes: [
        {
            path: '/reports/manager-track-report',
            name: 'ManagerTrackReport',
            components: { default: ManagerTrackReport },
            meta: {tab: 'manager-track-report', toolbars: ['Search'], report: true}
        },
        {
            path: '/reports/realisation-errors-report',
            name: 'RealisationErrorsReport',
            components: { default: RealisationErrorsReport },
            meta: {tab: 'realisation-errors-report', toolbars: ['Search'], report: true}
        },
        {
            path: '/reports/missing-documents-report',
            name: 'MissingDocumentsReport',
            components: { default: MissingDocumentsReport },
            meta: {tab: 'missing-documents-report', toolbars: ['Search'], report: true}
        },
        {
            path: '/reports/payment-report',
            name: 'PaymentReport',
            components: { default: PaymentReport },
            meta: {tab: 'payment-report', toolbars: ['Search'], report: true}
        },
        {
            path: '/reports/dispatcher-report',
            name: 'DispatcherReport',
            components: { default: DispatcherReport },
            meta: {tab: 'dispatcher-report', toolbars: [], report: true}
        },
        {
            path: '/reports/transfer-report',
            name: 'TransferReport',
            components: { default: TransferReport },
            meta: {tab: 'transfer-report', toolbars: ['Transfer'], report: true}
        },
        {
            path: '/reports/forwarding-report',
            name: 'ForwardingReport',
            components: { default: ForwardingReport },
            meta: {tab: 'forwarding-report', toolbars: ['Forwarding'], report: true}
        },
        {
            path: '/reports/services-report',
            name: 'ServicesReport',
            components: { default: ServicesReport },
            meta: {tab: 'services-report', toolbars: ['Services'], report: true}
        },
        {
            path: '/reports/routelist-report',
            name: 'RoutelistReport',
            components: { default: RoutelistReport },
            meta: {tab: 'routelist-report', toolbars: ['Routelist'], report: true}
        },
        {
            path: '/reports/noforwarding-report',
            name: 'NoForwardingReport',
            components: { default: NoForwardingReport },
            meta: {tab: 'noforwarding-report', toolbars: ['NoForwarding'], report: true}
        }
    ]
}



// WEBPACK FOOTER //
// ./src/modules/reports/routes.js